// Posición de scroll por entrada del historial (G4, cierre F1, QA DOC-49). Acotada a las
// últimas MAX_POSITIONS entradas: una sesión larga no acumula claves sin fin.

export const MAX_POSITIONS = 50;

const positions = new Map<string, number>();

/** Guarda la posición de `key` como la más reciente; descarta la más antigua si sobra. */
export function rememberPosition(key: string, y: number): void {
  positions.delete(key);
  positions.set(key, y);
  if (positions.size > MAX_POSITIONS) {
    const oldest = positions.keys().next().value;
    if (oldest !== undefined) {
      positions.delete(oldest);
    }
  }
}

export function positionOf(key: string): number {
  return positions.get(key) ?? 0;
}

export function positionCount(): number {
  return positions.size;
}
